import { useContext } from 'react';
import { ProgressStepContext, type ProgressStepContextValue } from '@/contexts/progressStepContext';

export const useProgressStep = (): ProgressStepContextValue => useContext(ProgressStepContext);
